import { v4 as uuidv4 } from 'uuid';

import { appConfig } from '../../../config/config.app';
import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { get } from '../../http';

export interface MarriottAuthorizeRequest {
  redirect_uri: string;
  response_type: string;
  scope?: string;
  state: string;
}

export const getMarriottBonvoyAuthorizeURI = (redirect_uri: string, state: string) => {
  return `${appConfig.authorizationApiUrl}/marriott/authorize?redirect_uri=${redirect_uri}&response_type=code&state=${state}`;
};

export const marriottAuthorizeRequest = async (requestParams: Partial<MarriottAuthorizeRequest>) => {
  try {
    const { redirect_uri = '', state = uuidv4() } = requestParams;
    const response = await (await get(getMarriottBonvoyAuthorizeURI(redirect_uri, state))).json();

    evaluateResponseErrorCode(response);
    if (response?.error) throw response.error;

    return response;
  } catch (error) {
    throw getApiError(error);
  }
};
